<template>
    <div class="market_filter">
        <b-overlay :show="is_load">
            <b-tabs content-class="mt-3">
                <b-tab active>
                    <template #title>
                        {{ __t('Go Direct') }}
                        <b-badge variant="secondary" class="ml-1">
                            {{ selectedGeneralCount }} / {{ general_locations.length }}
                        </b-badge>
                    </template>

                    <payment_location_list
                        prefix="general"
                        :locations="general_locations"
                        :attached-location-ids="attached_location_ids"
                        :attached-locations="attached_locations"
                        @toggle="toggleLocation"
                    />
                </b-tab>

                <b-tab>
                    <template #title>
                        {{ __t('Go Direct QR') }}
                        <b-badge variant="secondary" class="ml-1">
                            {{ selectedQrCount }} / {{ qr_locations.length }}
                        </b-badge>
                    </template>

                    <payment_location_list
                        prefix="qr"
                        :locations="qr_locations"
                        :attached-location-ids="attached_location_ids"
                        :attached-locations="attached_locations"
                        @toggle="toggleLocation"
                    />
                </b-tab>

                <b-tab>
                    <template #title>
                        {{ __t('API') }}
                        <b-badge variant="secondary" class="ml-1">
                            {{ selectedApiCount }} / {{ api_locations.length }}
                        </b-badge>
                    </template>

                    <payment_location_list
                        prefix="api"
                        :locations="api_locations"
                        :attached-location-ids="attached_location_ids"
                        :attached-locations="attached_locations"
                        @toggle="toggleLocation"
                    />
                </b-tab>
            </b-tabs>
        </b-overlay>
    </div>
</template>

<script>
import payment_location_list from "./payment_location_list.vue";

export default {
    name: "payment_attached_locations",
    props : {
        in_item : {
            type : Object
        },
        atr_name : {
            type : String,
            default : "attached_location_ids",
        },
    },

    components : {
        payment_location_list,
    },

    created() {
        this.loadAttachedPaymentByGate();
        this.load_locations();
    },

    data() {
        return {
            is_load: false,
            locations : [],
            attached_locations : [],
        }
    },

    methods: {

        async loadAttachedPaymentByGate() {
            this.attached_locations = [];
            api.get('/internal/v1/catalog/pwa/payments/gates/' +this.in_item.pay_gate_id + '/payment/'+ this.in_item.id +'/attached_payments').then(({data}) => {
                if (data.status === "operation_success") {
                    this.attached_locations = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        async load_locations() {
            this.is_load =  true;
            this.locations = [];
            agr_api.get('/aggregators/10/locations').then(({data}) => {
                this.is_load =  false;
                if (data.status === "operation_success") {
                    this.locations = data.data;
                }
            }).catch(({response}) => {
                this.is_load =  false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },


        async toggleLocation(loc) {
            if (this.isLocationLocked(loc.id)) {
                return;
            }

            const id = String(loc.id);
            const ids = Array.isArray(this.in_item[this.atr_name])
                ? this.in_item[this.atr_name].map(item => String(item))
                : [];

            if (ids.includes(id)) {
                this.in_item[this.atr_name] = ids.filter(lid => lid !== id);
            } else {
                this.in_item[this.atr_name] = [...ids, id];
            }

            this.$emit('on_change_attribute', this.atr_name, this.in_item[this.atr_name]);
        },

        isLocationLocked(locId) {
            const attached = this.attached_locations.find(item => {
                return String(item.loc_id) === String(locId);
            });

            if (!attached || !attached.attached_id) {
                return false;
            }

            return String(attached.attached_id.setting_id) !== String(this.in_item.id);
        }
    },

    computed : {
        general_locations() {
            return this.locations.filter(item => {return item.provider === 'pwa' && item.is_qr_location == false})
        },

        qr_locations() {
            return this.locations.filter(item => {return item.provider === 'pwa' && item.is_qr_location == true})
        },

        api_locations() {
            return this.locations.filter(item => {return item.provider === 'api'})
        },

        attached_location_ids() {
            return Array.isArray(this.in_item[this.atr_name])
                ? this.in_item[this.atr_name].map(item => String(item))
                : [];
        },

        selectedGeneralCount() {
            return this.general_locations.filter(loc => {
                return this.attached_location_ids.includes(String(loc.id));
            }).length;
        },

        selectedQrCount() {
            return this.qr_locations.filter(loc => {
                return this.attached_location_ids.includes(String(loc.id));
            }).length;
        },

        selectedApiCount() {
            return this.api_locations.filter(loc => {
                return this.attached_location_ids.includes(String(loc.id));
            }).length;
        },


    },
}
</script>



<style scoped>

</style>
